import { observable, action, computed, decorate } from 'mobx'
import { auth, logout } from '../sources/SessionSource'
import redirect from '../../src/lib/redirect'
class SessionStore {
  user = null

  get isLoggedIn () {
    return !!this.user
  }

  authenticate () {
    return auth()
      .then((userData) => this.authSuccess(userData), () => this.cleanSession())
      .catch(err => console.error('Error parsing auth response', err))
  }

  authSuccess (userData) {
    this.user = userData.body
  }

  cleanSession () {
    this.user = null
  }

  handleLogout () {
    return logout()
      .then(() => {
        this.cleanSession()
        redirect.redirectToCorp()
      })
      .catch(err => console.error('There was an error logging you out.', err))
  }

  get getExpiration() {
    const expirationTime = this.user?.sessionExpiresAt
    if (!expirationTime) return
    
    return expirationTime
  }

  get userName () {
    const name = `${this.user.firstName} ${this.user.lastName.charAt(0)}.`
    return name.trim() || 'Welcome'
  }
}

decorate(SessionStore, {
  user: observable,
  userName: computed,
  isLoggedIn: computed,
  authenticate: action,
  authSuccess: action,
  cleanSession: action,
  handleLogout: action,
  getExpiration: computed,
})

const sessionStore = new SessionStore()
export default sessionStore
